const types = {
  FETCH_OPERATOR_VEHICLE_LISTING_START: 'FETCH_OPERATOR_VEHICLE_LISTING_START',
  FETCH_OPERATOR_LISTING_SUCCESS: 'FETCH_OPERATOR_LISTING_SUCCESS',
  FETCH_OPERATOR_VEHICLE_LISTING_FAILURE: 'FETCH_OPERATOR_VEHICLE_LISTING_FAILURE',
  ALTER_OPERATOR_LISTING: 'ALTER_OPERATOR_LISTING',
  FETCH_OPERATOR_VEHICLE_TYRE_LISTING_START: 'FETCH_OPERATOR_VEHICLE_TYRE_LISTING_START',
  FETCH_OPERATOR_VEHICLE_TYRE_LISTING_SUCCESS: 'FETCH_OPERATOR_VEHICLE_TYRE_LISTING_SUCCESS',
  FETCH_OPERATOR_VEHICLE_TYRE_LISTING_FAILURE: 'FETCH_OPERATOR_VEHICLE_TYRE_LISTING_FAILURE',

  POST_UPLOAD_DOC_START: 'POST_UPLOAD_DOC_START',
  POST_UPLOAD_DOC_SUCCESS: 'POST_UPLOAD_DOC_SUCCESS',
  POST_UPLOAD_DOC_FAILURE: 'POST_UPLOAD_DOC_FAILURE',

  GET_UPLOADED_IMAGES_START: 'GET_UPLOADED_IMAGES_START',
  GET_UPLOADED_IMAGES_SUCCESS: 'GET_UPLOADED_IMAGES_SUCCESS',
  GET_UPLOADED_IMAGES_FAILURE: 'GET_UPLOADED_IMAGES_FAILURE',

  GET_UPLOADED_RC_BACK_IMAGES_START: 'GET_UPLOADED_RC_BACK_IMAGES_START',
  GET_UPLOADED_RC_BACK_IMAGES_SUCCESS: 'GET_UPLOADED_RC_BACK_IMAGES_SUCCESS',
  GET_UPLOADED_RC_BACK_IMAGES_FAILURE: 'GET_UPLOADED_RC_BACK_IMAGES_FAILURE',

  POST_VEHICLE_DATA_UPDATE_START: 'POST_VEHICLE_DATA_UPDATE_START',
  POST_VEHICLE_DATA_UPDATE_SUCCESS: 'POST_VEHICLE_DATA_UPDATE_START',
  POST_VEHICLE_DATA_UPDATE_FAILURE: 'POST_VEHICLE_DATA_UPDATE_START',

  POST_VEHICLE_DATA_UPDATE_START_V2: 'POST_VEHICLE_DATA_UPDATE_START_V2',
  POST_VEHICLE_DATA_UPDATE_SUCCESS_V2: 'POST_VEHICLE_DATA_UPDATE_SUCCESS_V2',
  POST_VEHICLE_DATA_UPDATE_FAILURE_V2: 'POST_VEHICLE_DATA_UPDATE_FAILURE_V2',

  GET_RESOURCE_KEY_RC_FRONT: 'GET_RESOURCE_KEY_RC_FRONT',
  GET_RESOURCE_KEY_RC_BACK: 'GET_RESOURCE_KEY_RC_BACK',

  UPDATE_VEHICLE_SUCCESS: 'UPDATE_VEHICLE_SUCCESS',

  OPERATOR_DOC_LIST_START: 'OPERATOR_DOC_LIST_START',
  OPERATOR_DOC_LIST_SUCCESS: 'OPERATOR_DOC_LIST_SUCCESS',
  OPERATOR_DOC_LIST_FAILURE: 'OPERATOR_DOC_LIST_FAILURE',

  FETCH_OPERATOR_ACTIVE_SCREEN: 'FETCH_OPERATOR_ACTIVE_SCREEN',
  FETCH_OPERATOR_IS_YOUR_VEHICLE: 'FETCH_OPERATOR_IS_YOUR_VEHICLE',
  FETCH_OPERATOR_VEHICLE_BODYTYPE: 'FETCH_OPERATOR_VEHICLE_BODYTYPE',
  FETCH_OPERATOR_VEHICLE_TUN: 'FETCH_OPERATOR_IS_YOUR_TUN',
  FETCH_OPERATOR_VEHICLE_SIZE: 'FETCH_OPERATOR_VEHICLE_SIZE',
  FETCH_OPERATOR_VEHICLE_TYRE: 'FETCH_OPERATOR_VEHICLE_TYRE',
  // FETCH_OPERATOR_VEHICLE_HEIGHT: 'FETCH_OPERATOR_VEHICLE_HEIGHT',
  FETCH_OPERATOR_VEHICLE_FRONT_RC: 'FETCH_OPERATOR_VEHICLE_FRONT_RC',
  FETCH_OPERATOR_VEHICLE_BACK_RC: 'FETCH_OPERATOR_VEHICLE_BACK_RC',
  FETCH_OPERATOR_VEHICLE_SELECTED_NUMBER: 'FETCH_OPERATOR_VEHICLE_SELECTED_NUMBER',
  FETCH_OPERATOR_VEHICLE_SELECTED_TYRE: 'FETCH_OPERATOR_VEHICLE_SELECTED_TYRE',

  FETCH_OPERATOR_VEHICLE_SELECTED_SIZE: 'FETCH_OPERATOR_VEHICLE_SELECTED_SIZE',

  FETCH_OPERATOR_VEHICLE_SELECTED_TUN: 'FETCH_OPERATOR_VEHICLE_SELECTED_TUN',

  FETCH_OPERATOR_VEHICLE_SELECTED_HEIGHT: 'FETCH_OPERATOR_VEHICLE_SELECTED_HEIGHT',
  FETCH_OPERATOR_VEHICLE_SELECTED_BODY: 'FETCH_OPERATOR_VEHICLE_SELECTED_BODY',

  OPERATOR_POST_UPLOAD_DOC_START: 'OPERATOR_POST_UPLOAD_DOC_START',
  OPERATOR_POST_UPLOAD_DOC_SUCCESS: 'OPERATOR_POST_UPLOAD_DOC_SUCCESS',
  OPERATOR_POST_UPLOAD_DOC_FAILURE: 'OPERATOR_POST_UPLOAD_DOC_FAILURE',

  GET_RESOURCE_KEY_AAADHAR_FRONT: 'GET_RESOURCE_KEY_AAADHAR_FRONT',
  GET_RESOURCE_KEY_AAADHAR_BACK: 'GET_RESOURCE_KEY_AAADHAR_BACK',

  OPERATOR_GET_UPLOADED_IMAGES_START: 'OPERATOR_GET_UPLOADED_IMAGES_START',
  OPERATOR_GET_UPLOADED_IMAGES_SUCCESS: 'OPERATOR_GET_UPLOADED_IMAGES_SUCCESS',
  OPERATOR_GET_UPLOADED_IMAGES_FAILURE: 'OPERATOR_GET_UPLOADED_IMAGES_FAILURE',

  OPERATOR_GET_UPLOADED_BACK_IMAGES_START: 'OPERATOR_GET_UPLOADED_BACK_IMAGES_START',
  OPERATOR_GET_UPLOADED_BACK_IMAGES_SUCCESS: 'OPERATOR_GET_UPLOADED_BACK_IMAGES_SUCCESS',
  OPERATOR_GET_UPLOADED_BACK_IMAGES_FAILURE: 'OPERATOR_GET_UPLOADED_BACK_IMAGES_FAILURE',

  POST_OPERATOR_DATA_UPDATE_START: 'POST_OPERATOR_DATA_UPDATE_START',
  POST_OPERATOR_DATA_UPDATE_SUCCESS: 'POST_OPERATOR_DATA_UPDATE_SUCCESS',
  POST_OPERATOR_DATA_UPDATE_FAILURE: 'POST_OPERATOR_DATA_UPDATE_FAILURE',

  FETCH_GPS_IMAGE_URLS: 'FETCH_GPS_IMAGE_URLS',
  FETCH_GPS_IMAGE_URLS_SUCCESS: 'FETCH_GPS_IMAGE_URLS_SUCCESS',
  FETCH_GPS_IMAGE_URLS_FAILURE: 'FETCH_GPS_IMAGE_URLS_FAILURE',
  GPS_ORDER_REQUEST: 'GPS_ORDER_REQUEST',
  GPS_ORDER_REQUEST_SUCCESS: 'GPS_ORDER_REQUEST_SUCCESS',
  GPS_ORDER_REQUEST_FAILURE: 'GPS_ORDER_REQUEST_FAILURE',
  FETCH_GPS_VARIANT: 'FETCH_GPS_VARIANT',
  FETCH_GPS_VARIANT_SUCCESS: 'FETCH_GPS_VARIANT_SUCCESS',
  FETCH_GPS_VARIANT_FAILURE: 'FETCH_GPS_VARIANT_FAILURE',
  UPLOAD_DOCUMENT: 'ONBAORDING/UPLOAD_DOCUMENT',
  UPLOAD_DOCUMENT_SUCCESS: 'ONBAORDING/UPLOAD_DOCUMENT_SUCCESS',
  UPLOAD_DOCUMENT_FAILURE: 'ONBAORDING/UPLOAD_DOCUMENT_FAILURE',
  CLEAR_DOCUMENTS: 'ONBAORDING/CLEAR_DOCUMENTS',
  CLEAR_DOCUMENT: 'ONBAORDING/CLEAR_DOCUMENT',
  FETCH_VEH_REQ_DATA: 'FETCH_VEH_REQ_DATA',
  FETCH_VEH_REQ_DATA_SUCCESS: 'FETCH_VEH_REQ_DATA_SUCCESS',
  FETCH_VEH_REQ_DATA_FAILURE: 'FETCH_VEH_REQ_DATA_FAILURE',
  SET_VEHICLE_FORM_DATA: 'SET_VEHICLE_FORM_DATA',
};

export default types;
